import type { ObjectKeys } from '../interfaces/ObjectKeys'

// Order determines order in sidebar
export const facetsProducts: ObjectKeys = {
  category: {
    label: 'Product Line'
  },
  vendor: {
    label: 'Brand'
  },
  category_2: {
    label: 'Product Type'
  }
}

export const facetsKeysProducts = Object.keys(facetsProducts)
